"use client";

import { useState } from "react";
import OTPLogin from "../otp-login";
import InfoHeader from "./info-header";
import Login from "./login";
import Register from "./register";

type FormSteps = "login" | "register" | "sent";
const LoginForm = ({
  isApp = false,
  redirectUrl,
}: {
  isApp?: boolean;
  redirectUrl?: string;
}) => {
  const [error, setError] = useState<null | { message: string }>(null);
  const [step, setStep] = useState<FormSteps>("login");
  const [email, setEmail] = useState<string | null>(null);

  const resetForm = () => {
    setStep("login");
    setError(null);
    setEmail(null);
  };

  const nextStep = (step: FormSteps) => {
    setError(null);
    setStep(step);
  };

  return (
    <>
      {step !== "sent" && (
        <div className="space-y-6">
          {step === "login" && (
            <Login
              redirectUrl={redirectUrl}
              isApp={isApp}
              onSuccess={(email, createdUser) => {
                nextStep(createdUser ? "register" : "sent");
                setEmail(email);
              }}
              onError={(message) => setError({ message })}
            />
          )}
          {step === "register" && email && (
            <>
              <Register
                isApp={isApp}
                onSuccess={() => {
                  nextStep("sent");
                }}
                onError={(message) => setError({ message })}
                email={email}
              />
            </>
          )}
          {error?.message && (
            <div className="text-red-500 border-2 border-red-500 p-3">
              <p>{error?.message}</p>
            </div>
          )}
        </div>
      )}

      {step == "sent" && (
        <div className="space-y-8">
          {!error && <InfoHeader header="Kolla din e-post" description="" />}
          {error && <p className="text-red-500 mt-5">{error.message}</p>}
          <p className="">
            Vi har skickat ett e-postmeddelande till dig från EFN. Ange koden
            som du hittar i meddelandet i fältet nedanför eller klicka på länken
            i meddelandet för att fortsätta.
          </p>

          <OTPLogin
            email={email || undefined}
            redirectUrl={redirectUrl}
            isApp={isApp}
          />

          <p>
            {" "}
            Om du inte hittar mejlet, kontrollera gärna skräppostmappen eller{" "}
            <a href="#" className="underline text-comp-800" onClick={resetForm}>
              skicka ett nytt mail.
            </a>
          </p>
        </div>
      )}
    </>
  );
};

export default LoginForm;
